import { isEmpty } from '@/helpers/string.helpers'
import { api } from '@/services/api'
import { OnStartServiceHookDTO, StartServiceDTO } from './types'
import { findWebhookConfigByCompany } from '../../../_http/webhook'

export async function onStartServiceHook({ currentChat, companyId }: OnStartServiceHookDTO) {
  try {
    const { config } = await findWebhookConfigByCompany(companyId)
    if (isEmpty(config)) return
    if (isEmpty(config?.onServiceStart)) return
    const url = config.onServiceStart
    const dto: StartServiceDTO = {
      chat: {
        id: currentChat.id,
        chatName: currentChat.chatName,
        ticket: currentChat.ticket,
        lastMessage: currentChat.lastMessage,
        unreadMessagesCount: currentChat.unreadMessagesCount,
        operators: currentChat.operators,
        requesterNumber: currentChat.requesterNumber,
        receiverNumber: currentChat.receiverNumber,
        startDate: currentChat.startDate,
        endDate: currentChat.endDate,
        duration: currentChat.duration,
        status: currentChat.status,
        createdAt: currentChat.createdAt,
        updatedAt: currentChat.updatedAt,
        type: 'StartServiceCallback'
      }
    }
    await api.post(url, dto)
  } catch (error) {
    console.log('onStartServiceHook error', error)
  }
}
